import AdvancedNumberInput, { type AdvancedNumberInputProps } from './AdvancedNumberInput'
import env from '../config/env'

const PRICE_STEP = 0.01

const AdvancedPriceNumberInput = ({
  min = 0,
  step = PRICE_STEP,
  unit = env.CURRENCY_SYMBOL,
  ...props
}: AdvancedNumberInputProps) => (
  <AdvancedNumberInput
    {...props}
    min={min}
    step={step}
    unit={unit}
    format={(v) => (v == null ? null : Number(v) / 100)}
    parse={(v) => Math.round(Number(v) * 100)}
  />
)

export default AdvancedPriceNumberInput
